<script>
    import { fade, fly, slide, scale } from 'svelte/transition';
    import { cubicIn, bounceInOut } from 'svelte/easing';
</script>

<style>
    span{
        display: inline-block;
        margin: 0 0.25rem;
        border-radius: 3px;
        border: 1px solid #cf0056;
        background-color: #cf0056;
        color: white;
        padding: 0 0.5rem;
        font-family: Lato,sans-serif;
        font-size:0.8rem;
    }
</style>


<span transition:fade><slot/></span>